import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LinkContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: string }>(({ active, theme }) => ({
  display: 'flex',
  borderBottom: `2px solid ${
    active === 'true' ? theme.palette.common.white : theme.palette.darkGray.main
  }`,
  alignItems: 'center',
  width: '80px',
  justifyContent: 'center',
  fontWeight: '400',
  '&:hover': {
    borderColor: theme.palette.common.white,
  },
}));
